import { render, staticRenderFns } from "./DashboardDropdown.vue?vue&type=template&id=53f0d8b2&scoped=true&"
import script from "./DashboardDropdown.vue?vue&type=script&lang=js&"
export * from "./DashboardDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDropdown.vue?vue&type=style&index=0&id=53f0d8b2&prod&scoped=true&lang=css&"
import style1 from "./DashboardDropdown.vue?vue&type=style&index=1&id=53f0d8b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0d8b2",
  null
  
)

export default component.exports